export default "__VITE_ASSET__CbqWfOXz__"